import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  titles: {
    draft: 'Votre commande (coût par mois)',
    main: 'Votre abonnement',
    billing_settings: 'Paramètres de facturation',
  },
  form: {
    billing_mode: {
      label: 'Mode de facturation',
    },
    has_trial: {
      label: "Ajouter des jours d'essai gratuits",
    },
    trial_days: {
      label: "Combien de jours d'essai souhaitez-vous ?",
      placeholder: '21',
      validation: {
        required: "Les jours d'essai sont requis",
        min: "{{value}} est la valeur minimale pour les jours d'essai",
        max: "{{value}} est la valeur maximale pour les jours d'essai",
      },
    },
  },
  fields: {
    created_at: 'Créé le <strong>{{date}}</strong> par <strong>{{manager}}</strong>',
    updated_at: 'Dernière mise à jour le <strong>{{date}}</strong> par <strong>{{manager}}</strong>',
    trial_ends_at: "En essai jusqu'au <strong>{{date}}</strong>",
    trial_days: "{{trialDays}} jours d'essai commencent à la date de lancement, vous serez facturé à la fin de l'essai",
    resumable_until: "Reprise possible jusqu'au <strong>{{date}}</strong>",
    ended_at: 'Terminé le <strong>{{date}}</strong>',
    next_bill_at: 'Prochaine facturation le <strong>{{date}}</strong>',
    product: 'Produit',
    quantity: 'Quantité',
    price: 'Prix HT',
    tax: 'TVA',
    amount: 'Montant',
    net: 'HT',
    tax_percentage: 'TVA {{rate}}%',
    total: 'Total facturé par mois',
  },
  billing_modes: {
    [BillingMode.Stripe]: 'Débit depuis le moyen de paiement',
    [BillingMode.InternalInvoicing]: 'Débit depuis les ventes',
  },
  labels: {
    included: 'inclus',
    sales_based_discount:
      "Un article du panier a un prix variable ; le prix réel sera calculé lors de la création/mise à jour de l'abonnement en fonction des ventes du mois précédent",
  },
  buttons: {
    edit: 'Modifier',
    cancel: 'Annuler',
    resume: 'Reprendre',
  },
  modals: {
    cancel_subscription: {
      title: "Annuler l'abonnement {{company}} ?",
      description:
        "Cela annulera l'abonnement sélectionné, y compris <strong>{{products}}</strong> (<strong>{{total}} au total</strong>). L'abonnement reste actif et peut être repris jusqu'au <strong>{{endsAt}}</strong>. S'il n'est pas repris d'ici là, un nouvel abonnement devra être créé.",
    },
    resume_subscription: {
      title: "Reprendre l'abonnement {{company}} ?",
      description:
        "Cela reprendra l'abonnement sélectionné, y compris <strong>{{products}}</strong>. Le restaurant est facturé <strong>{{total}}</strong> chaque mois, prochainement le <strong>{{nextBillingDate}}</strong>.",
      description_prorated:
        "Cela reprendra l'abonnement sélectionné, y compris <strong>{{products}}</strong>. Le premier prélèvement du <strong>{{nextBillingDate}}</strong> est calculé au prorata jusqu'au 5. Ensuite, le restaurant est facturé <strong>{{total}}</strong> le 5 de chaque mois.",
    },
  },
  toasts: {
    cancel_subscription:
      "Si vous souhaitez annuler votre abonnement, veuillez contacter votre interlocuteur {{provider}} par téléphone ou par e-mail. Il annulera l'abonnement immédiatement.",
    failed_to_cancel_subscription:
      "Une erreur s'est produite lors de l'annulation de l'abonnement. Veuillez contacter le support technique",
    resume_subscription:
      "Si vous souhaitez reprendre votre abonnement, veuillez contacter votre interlocuteur {{provider}} par téléphone ou par e-mail. Il reprendra l'abonnement immédiatement.",
    failed_to_resume_subscription:
      "Une erreur s'est produite lors de la reprise de l'abonnement. Veuillez contacter le support technique",
  },
};
